<template lang="pug">
  div
    section.header
      h2 4. Detalle de la reclamación y pedido del consumidor
      p
        span Por favor detalle lo sucedido y lo que espera de nosotros para solucionarlo
      hr

    transition-group.contenedor-transition(name="fade-smooth", tag="div", mode="out-in")
      .tipo-empresa-container(
        key="tipo-empresa"
      )
        label.label Seleccione el tipo de reclamación
        div.select-box
          .option.bd-color-empresa(
            v-for="o in tipos"
            :class="{ 'bg-empresa': detalle.tipo === o.codigo }"
            @click="seleccionarTipo(o)"
          )
            span {{ o.descripcion }}

      .description-box.message.is-info(
        v-if="detalle.tipo === 'queja'"
        key="queja-description"
      )
        div.message-body
          p Una queja es la disconformidad no relacionada a los productos o servicios; 
          p o, malestar o descontento respecto a la atención al público.

      .description-box.message.is-info(
        v-if="detalle.tipo === 'reclamo'"
        key="reclamo-description"
      )
        div.message-body
          p Una reclamo es la disconformidad relacionada a los productos o servicios

      .datos-persona-natural(
        key="datos"
      )
        .field
          label.label 
            | Detalle de reclamación
          .control
            textarea.textarea(rows='5', v-model="detalle.descripcion")
        .field
          label.label 
            | Pedido
          .control
            textarea.textarea(rows='5', v-model="detalle.pedido")

</template>
<script>
export default {
  name: 'box-detalle-pedido-consumidor',
  data () {
    return {
      detalle: {
        tipo: ''
      },
      tipos: [
        {codigo: 'reclamo', descripcion: 'Reclamo'},
        {codigo: 'queja', descripcion: 'Queja'}
      ]
    }
  },
  created () {

  },
  methods: {
    sendData () {
      this.$emit('send', this.detalle)
    },
    seleccionarTipo (o) {
      console.log('o.codigo:', o.codigo)
      this.detalle.tipo = o.codigo
      this.sendData()
    },
    clean () {
      this.detalle = {
        tipo: ''
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .select-box
    align-items center
    justify-content center
    .option
      max-width: 100px;
      text-align center     
  
  .contenedor-transition
    position relative
</style>



// WEBPACK FOOTER //
// Box-4-detalle-pedido-consumidor.vue?343eb542